<div style="display: flex; flex-direction: row; align-items: center; gap: 30px">
  <div>
    <div style="display: flex; flex-direction: row; gap: 5px">
      <app-input-date-customized
        [label]="'Partition.ArmedHour' | translate"
        [value]="schedule.arm1"
        (valueChange)="onArmedHourChange($event, 1)"
        [step]="10"
        [fieldName]="'arm'"
        [scheduleId]="schedule.id"
        class="input-date-customized"
        [disabled]="authService.isReadOnlyMode()"
      ></app-input-date-customized>

      <app-input-date-customized
        [label]="'Partition.DisarmedHour' | translate"
        [value]="schedule.disarm1"
        (valueChange)="onDisarmedHourChange($event, 1)"
        [step]="10"
        [fieldName]="'disarm'"
        [scheduleId]="schedule.id"
        class="input-date-customized"
        [disabled]="authService.isReadOnlyMode()"
      ></app-input-date-customized>
    </div>

    <div style="display: flex; flex-direction: row; gap: 5px">
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 5px; margin-top: 20px; margin-bottom: 30px">
        <app-input-date-customized
          [label]="'Partition.ArmedHour' | translate"
          [value]="schedule.arm2"
          (valueChange)="onArmedHourChange($event, 2)"
          [step]="10"
          [fieldName]="'arm'"
          [scheduleId]="schedule.id"
          class="input-date-customized"
          [disabled]="authService.isReadOnlyMode()"
        ></app-input-date-customized>

        <app-input-date-customized
          [label]="'Partition.DisarmedHour' | translate"
          [value]="schedule.disarm2"
          (valueChange)="onDisarmedHourChange($event, 2)"
          [step]="10"
          [fieldName]="'disarm'"
          [scheduleId]="schedule.id"
          class="input-date-customized"
          [disabled]="authService.isReadOnlyMode()"
        ></app-input-date-customized>
      </div>
      <mat-icon
        class="info-icon"
        [tooltipDeitres]="'Partition.ArmedHourTooltip' | translate"
        [tooltipCustomLeft]="-6"
        [tooltipCustomTop]="-160"
        tooltipSize="fit"
      >
        info
      </mat-icon>
    </div>

    <div *ngIf="errors != undefined && errors.length > 0" class="error-container">
      <div class="error-text" *ngFor="let error of errors">{{ 'Shared.' + error | translate }}</div>
    </div>
  </div>

  <div style="display: flex; flex-direction: row; gap: 5px; margin-bottom: 30px; align-items: center">
    <div class="days-container">
      <ng-container *ngFor="let day of daysEnum">
        <button
          class="circle-button truncate-text text-style"
          [ngClass]="{
            'circle-button-active': schedule.selectedDay[day],
            'circle-button-disabled': !schedule.selectedDay[day] && daysAlreadySelected[day]
          }"
          [tooltipDeitres]="'AppComponent.' + day | translate"
          [tooltipCustomLeft]="-4"
          [tooltipCustomTop]="-120"
          tooltipSize="fit"
          (click)="onDayButtonClick(day)"
          [disabled]="authService.isReadOnlyMode()"
        >
          {{ 'AppComponent.' + day | translate }}
        </button>
      </ng-container>
    </div>

    <button
      *ngIf="last"
      type="button"
      matSuffix
      mat-icon-button
      (click)="onNewScheduleButtonClick()"
      [disabled]="authService.isReadOnlyMode()"
      [style.marginLeft]="'5px'"
      [style.width]="'24px'"
    >
      <mat-icon
        class="info-icon"
        [tooltipDeitres]="'Shared.Add' | translate"
        [tooltipCustomLeft]="-6"
        [tooltipCustomTop]="-160"
        tooltipSize="fit"
      >
        add
      </mat-icon>
    </button>

    <button type="button" matSuffix mat-icon-button (click)="onDeleteButtonClick()" [disabled]="authService.isReadOnlyMode()" [style.width]="'24px'">
      <mat-icon
        class="info-icon"
        [tooltipDeitres]="'Shared.Delete' | translate"
        [tooltipCustomLeft]="-6"
        [tooltipCustomTop]="-160"
        tooltipSize="fit"
      >
        delete
      </mat-icon>
    </button>
  </div>
</div>
